(function () {
  var BLOCK_MSG =
    'This product is not available for online purchase. Please contact us for pricing.';

  var ZERO_PRICE_RE =
    /^(rs\.?|₹|inr|\$|€|£)?\s*0+([.,]0+)?(\s*(rs\.?|inr|usd|eur|gbp))?$/i;

  function getVariantPrice(variantId) {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (!data) continue;
        var variants = data.variants;
        if (!variants && data.product && data.product.variants) {
          variants = data.product.variants;
        }
        if (!variants) continue;
        for (var j = 0; j < variants.length; j++) {
          if (String(variants[j].id) === String(variantId)) {
            return variants[j].price;
          }
        }
      } catch (e) {
        /* ignore non-product JSON */
      }
    }
    return null;
  }

  function getFormVariantId(form) {
    var idInput = form.querySelector('[name="id"]');
    return idInput ? idInput.value : null;
  }

  function isZeroPriceVariant(variantId) {
    if (!variantId) return false;
    var price = getVariantPrice(variantId);
    return price === 0 || price === '0';
  }

  function isZeroMoneyText(text) {
    if (!text) return false;
    var cleaned = String(text).replace(/\u00a0/g, ' ').trim();
    if (!cleaned) return false;
    if (/on\s*enquiry/i.test(cleaned)) return true;
    return ZERO_PRICE_RE.test(cleaned);
  }

  function isHiddenNode(el) {
    if (!el || !el.closest) return true;
    if (el.closest('[hidden], template')) return true;
    if (el.getAttribute && el.getAttribute('aria-hidden') === 'true') return true;
    var parent = el.parentElement;
    while (parent) {
      if (parent.hasAttribute && parent.hasAttribute('hidden')) return true;
      parent = parent.parentElement;
    }
    return false;
  }

  function wrapHasVisibleRealPrice(wrap) {
    var moneys = wrap.querySelectorAll(
      '.hdt-money, .eh-lo__price, .eh-bg__price, .eh-new-season__price, .eh-exf__price, .eh-sf__price'
    );
    for (var i = 0; i < moneys.length; i++) {
      var m = moneys[i];
      if (isHiddenNode(m)) continue;
      var text = String(m.textContent || '')
        .replace(/\u00a0/g, ' ')
        .trim();
      if (!text) continue;
      if (!isZeroMoneyText(text)) return true;
    }
    return false;
  }

  function hideZeroPriceElements(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll(
      '.hdt-money, .eh-lo__price, .eh-bg__price, .eh-new-season__price, .eh-exf__price, .eh-sf__price, .eh-price-enquiry'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (isHiddenNode(el)) continue;
      if (!isZeroMoneyText(el.textContent)) continue;

      var wrap = el.closest(
        '.hdt-price-wrapp, .hdt-price__item, .eh-new-season__price-row, .eh-lo__buy-row, .eh-bg__buy-row'
      );

      // If the wrap still shows a real price (e.g. compare-at was rewritten to Rs. 0),
      // only hide this zero node — never the whole price block.
      if (wrap && wrapHasVisibleRealPrice(wrap)) {
        el.style.display = 'none';
        continue;
      }

      if (wrap) {
        wrap.classList.add('eh-zero-price');
        wrap.setAttribute('hidden', '');
        wrap.setAttribute('aria-hidden', 'true');
      }
      el.style.display = 'none';
    }
  }

  function blockFormSubmit(e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (
      !form.matches(
        'form[is="hdt-product-form"], form.hdt-product-form, form.hdt-main-product-form, form.hdt-sticky-atc__form'
      )
    ) {
      return;
    }

    var variantId = getFormVariantId(form);
    if (isZeroPriceVariant(variantId)) {
      e.preventDefault();
      e.stopPropagation();
      alert(BLOCK_MSG);
    }
  }

  async function cartHasZeroPriceItems() {
    try {
      var res = await fetch('/cart.js');
      if (!res.ok) return false;
      var cart = await res.json();
      return cart.items.some(function (item) {
        return item.price === 0 || item.final_price === 0;
      });
    } catch (e) {
      return false;
    }
  }

  async function removeZeroPriceItems() {
    try {
      var res = await fetch('/cart.js');
      if (!res.ok) return;
      var cart = await res.json();
      var zeroItems = cart.items.filter(function (item) {
        return item.price === 0 || item.final_price === 0;
      });
      for (var i = 0; i < zeroItems.length; i++) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: zeroItems[i].key, quantity: 0 }),
        });
      }
      if (zeroItems.length) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (e) {
      /* silent */
    }
  }

  async function blockCheckout(e) {
    var target = e.target.closest(
      '[name="checkout"], a[href*="/checkout"], .cart__checkout-button, .hdt-mini-cart__checkout, [data-checkout]'
    );
    if (!target) return;

    if (await cartHasZeroPriceItems()) {
      e.preventDefault();
      e.stopPropagation();
      await removeZeroPriceItems();
      alert(BLOCK_MSG);
    }
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
    var isCartAdd = url && url.indexOf('/cart/add') !== -1;

    return origFetch.apply(this, args).then(function (response) {
      if (isCartAdd && response.ok) {
        return removeZeroPriceItems().then(function () {
          return response;
        });
      }
      return response;
    });
  };

  document.addEventListener('submit', blockFormSubmit, true);
  document.addEventListener('click', blockCheckout, true);

  document.addEventListener('DOMContentLoaded', function () {
    hideZeroPriceElements();
    removeZeroPriceItems();
  });

  document.addEventListener('currency:update', function () {
    hideZeroPriceElements();
  });
  document.addEventListener('products:update', function () {
    hideZeroPriceElements();
  });
  document.addEventListener('facet:render', function () {
    hideZeroPriceElements();
  });

  if (typeof MutationObserver !== 'undefined') {
    var hideTimer = null;
    var mo = new MutationObserver(function () {
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        hideZeroPriceElements();
      }, 80);
    });
    function startMo() {
      mo.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    if (document.body) startMo();
    else document.addEventListener('DOMContentLoaded', startMo);
  }
})();
